<template>
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      <Icon name="general.eye" size="base" />
      <span>{{ header }}</span>
    </div>
    <div v-if="publicVisitsCount">
      <a :href="`/analytics_download/${itemId}`" data-testid="analytics-export-csv" class="font-bold text-base text-blue-500">Export list as CSV</a>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook/icon';
import { useViewerStatsStore } from '@/modules/viewer/store/useViewerStatsStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

const { groupStatsCount } = storeToRefs(useViewerStatsStore());
const { publicVisitsCount, id: itemId } = storeToRefs(useViewerItemStore());

const header = computed(() => {
  const total = publicVisitsCount.value;
  const last = groupStatsCount.value;

  if ((!total && !last) || total === last) {
    return pluralize(total || 0, ' view');
  }

  return `${pluralize(total || 0, ' view')} (all time), ${pluralize(last, ' unique view')} (last 30 days)`;
});

const pluralize = (count: number, msg: string) => {
  return `${count}${msg}${count === 1 ? '' : 's'}`;
};
</script>
